import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

export const useBookmarkContentCreate = () => {
  const createContentBookmark = useCallback((payload) => {
    return new Request(`${MONOLITH_ORIGIN}/api/v3/content-bookmark/`, {
      body: JSON.stringify(payload),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
  }, []);

  return useRestMutation(createContentBookmark);
};

export default useBookmarkContentCreate;
